module.exports = __webpack_public_path__ + "img/66befb587f00ba78a6a7b216b8d16dd8.png";